import ErrorDisplayComponent from '../Components/ErrorDisplayComponent';
import loadingScreenComponent from '../Components/LoadingScreenComponent';
import ToggleButtonsComponent from '../Components/ToggleButtonsComponent';

/* eslint no-param-reassign: ["error", {
  "props": true,
  "ignorePropertyModificationsFor": ["button"]
}] */

class JsonReader {
  title = 'JSON Structure Abstract';

  constructor(link) {
    /**
     * @type {EsgItem[]|null}
     */
    this.json = null;
    this.link = link;
    this.dom_contents = document.getElementById('contents');
    this.dom_output = document.getElementById('output');
    this.dom_title = document.getElementById('title');
    this.dom_jsonoutput = document.getElementById('json');
  }

  /**
   * Fetch json data
   * @returns {Promise<any>}
   */
  async _fetchJson() {
    try {
      const response = await fetch(this.link);
      this.json = await response.json();
      return this.json;
    } catch (error) {
      throw Error(
        `Could not load JSON data from ${this.link}. <br />Error response: ${error.message}`
      );
    }
  }

  /**
   * Displays the json data
   * @returns {Promise<void>}
   */
  async show() {
    this._renderLoadingScreen();

    try {
      this._fetchJson()
        .then((json) => {
          this._render(ToggleButtonsComponent, json);
          this.displayItems();
          document.querySelector('#initial-item').classList.remove('hidden');
        })
        .catch((e) => {
          this._renderError('Fetch Error', e.message);
        });
    } catch (e) {
      this._renderError('Undefined error', e.message);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  displayItems() {
    throw new Error('You have to implement the method displayItems!');
  }

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  renderEsgItemAnswers(esgItem) {
    throw new Error('You have to implement the method renderEsgItemAnswers!');
  }

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  renderEsgItemAnswersDebug(esgItem) {
    throw new Error('You have to implement the method renderEsgItemAnswers!');
  }

  /**
   * Renders the given content
   * @param {string} html HTML output
   * @param {object} json json original contents
   */
  _render(html, json) {
    this.dom_output.classList.remove('invisible');
    this.dom_title.textContent = this.title;
    this.dom_contents.innerHTML = html;
    this.dom_jsonoutput.innerHTML = JSON.stringify(json, null, 2);
  }

  /**
   * Append some html-content to the existing content
   * @param {string} html
   */
  _addContents(html) {
    this.dom_contents.innerHTML += html;
  }

  /**
   * Renders a loading screen
   */
  _renderLoadingScreen() {
    this._render(loadingScreenComponent, `waiting for JSON-Data from ${this.link}`);
  }

  /**
   * Renders an error
   * @param {string} title title of the error
   * @param {string} message message describing the error
   */
  _renderError(title, message) {
    this._render(ErrorDisplayComponent(title, message), this.json);
  }

  /**
   * Handles the click event of each answer-buttons toggle button
   * @param {HTMLButtonElement} button
   */
  esgButtonToggleButtonClick(button) {
    // if only one element is selectable, unselect the other answer elements
    if (button.dataset.gate === 'xor') {
      const activeAnswerButton = document.querySelector(
        `#${button.dataset.parent}-item .esg-answer-button.esg-answer-opened`
      );
      if (activeAnswerButton !== null) {
        this._toggleChildrenEsgItems(activeAnswerButton);
      }
    }

    this._toggleChildrenEsgItems(button);
  }

  /**
   * Expands or collapse one answer-button
   * @param {HTMLButtonElement} button
   * @private
   */
  // eslint-disable-next-line class-methods-use-this
  _toggleChildrenEsgItems(button) {
    const answerId = button.dataset.answer;

    if (button.disabled) {
      document
        .querySelectorAll(`.esg-close-${answerId}`)
        .forEach((el) => el.classList.add('hidden'));
      button.classList.remove('esg-answer-opened');
      button.disabled = false;
      button.dataset.children
        .split(',')
        .forEach((id) => document.getElementById(`${id}-item`)?.classList.add('hidden'));
    } else {
      button.classList.add('esg-answer-opened');
      button.disabled = true;
      button.dataset.children
        .split(',')
        .forEach((id) => document.getElementById(`${id}-item`)?.classList.remove('hidden'));
    }
  }

  // eslint-disable-next-line class-methods-use-this
  closeAllEsgItems() {
    document
      .querySelectorAll('.esg-item:not(#initial-item)')
      .forEach((esgItem) => esgItem.classList.add('hidden'));
    document.querySelectorAll('.esg-answer-button').forEach((button) => {
      // eslint-disable-next-line no-param-reassign
      button.disabled = false;
    });
  }

  // eslint-disable-next-line class-methods-use-this
  showAllEsgItems() {
    document.querySelectorAll('.esg-item').forEach((esgItem) => esgItem.classList.remove('hidden'));
    document.querySelectorAll('.esg-answer-button').forEach((button) => {
      button.disabled = false;
    });
  }

  // eslint-disable-next-line class-methods-use-this
  toggleStructureInfo() {
    document.body.classList.toggle('esg-debug-activated');
  }
}

export default JsonReader;
